import React from "react";

const Loading = () => {
  return (
    <section className="flex flex-col items-center justify-center gap-12 w-full h-screen bg-dry">
      <img
        src="/images/diamond_logo_sm.png"
        alt="404"
        className="w-full max-h-40 object-contain m-4 "
      />
      <span className="loader block w-4 h-4 rounded-full relative animate-flash" />
    </section>
  );
};

export default Loading;
